import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { AuthService } from 'src/app/providers/auth-service/auth-service';
import { InstitutionService } from '../../providers/institution-service/institution-service';
import { TransactionService } from '../../providers/transaction-service/transaction-service';
import { ProjectService } from '../../providers/project-service/project-service';

import { Project } from 'src/app/models/Project';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.page.html',
  styleUrls: ['./transactions.page.scss'],
})
export class TransactionsPage implements OnInit {

  loading: boolean = true;
  project: Project;

  transactions: any[] = [];

  page: number = 0;

  accountOptions: any[] = [];
  accountIdsFilter: any[] = [];

  constructor(
    private projectService: ProjectService,
    private institutionService: InstitutionService,
    private transactionService: TransactionService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    ) { }

    ngOnInit() {
      this.loadProject().then(async (project) => {
        this.updatePage();

      });
    }

    loadProject() {
      return new Promise(async (resolve, reject) => {
        let projectId = this.activatedRoute.snapshot.paramMap.get('projectId');
        let currentUrl = "/transactions";
        this.project = this.projectService.getCurrentProject();
        this.projectService.isReady().then(() => {
          this.projectService.getLastOpenedProject().then((lastOpenedProject) => {
  
            if (this.project && this.project.id == projectId) { // current Project was set
              return resolve(this.project);
            }
  
            if (projectId) {
              this.projectService.setCurrentProject(projectId).then(() => {
                this.project = this.projectService.getCurrentProject();
                this.loading = false;
                return resolve(this.project);
              });
            } else if (!projectId) {
  
              if (lastOpenedProject.id) { // get the last opened project
                this.projectService.setCurrentProject(lastOpenedProject.id).then(() => {
                  this.project = this.projectService.getCurrentProject();
                  this.location.replaceState(this.projectService.currentProject.id + currentUrl);
                  this.loading = false;
                  return resolve(this.project);
                });
  
              } else {
                // no Project Created yet
                //this.createProject();
                this.loading = false;
                return resolve(this.project);
              }
  
            }
  
          });
        });
      });
    }
  

  ionViewWillEnter() {
    if(this.project) this.updatePage();
  }

  onAccountChange(event) {
    this.accountIdsFilter = [event.value];
    this.updateTransactions();
  }
  
    updatePage() {
      this.loading = true;
      this.accountOptions = [];
      const accounts = this.projectService.getCachedAccounts();
      accounts.forEach((account) => {
        let option = {
          title: account.accountName,
          subtitle: this.institutionService.formatIban(account.iban),
          classSubtitle: "is-sensitive is-iban",
          value: account.id
        } as any;
        this.accountOptions.push(option);
      });
      this.updateTransactions();

    }

    updateTransactions() {
      this.loading = true;
      this.transactionService.getTransactions(this.projectService.currentProject.id,{
        page: this.page,
        accountIds: this.accountIdsFilter
      }).then((result) => {
        this.loading = false;
        this.transactions = result.transactions;
      });
    }


}
